<template>
	<div class="row items-center full-height">
		<div class="col-12">
			<vue-plyr
				ref="plyr"
				:options="{ listeners: { seek: activity.user_watch ? '' : seekVideo }, speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] } }"
				class="video"
			>
				<div data-plyr-provider="youtube" :data-plyr-embed-id="source"></div>
			</vue-plyr>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'YouTubePlayer',

	props: ['activity'],

	data() {
		return {
			changed_time: false,
			current_time: 0,
			id_course: '',
			id_trail: '',
			interval: null,
			source: '',
			total_time: 0,
		}
	},

	computed: {
		...mapGetters({
			activities: 'activities/activities',
			hierarchy_order: 'activities/hierarchy_order',
			id: 'activities/id',
		}),

		player() {
			return this.$refs.plyr.player
		},
	},

	methods: {
		sendPosition() {
			if (
				this.$isInvalidNumericString(this.current_time) ||
				this.$isInvalidNumericString(this.player.duration)
			)
				return

			if (this.current_time != 0 && this.current_time != '') {
				let fd = new FormData()
				fd.append('current_time', this.current_time)
				fd.append('total_time', this.player.duration)
				fd.append('id_group_training_module', this.activity.type_id)

				let url = ''
				if (this.id_trail === '')
					url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
				else
					url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`

				this.$axios
					.post(url, fd)
					.then((response) => {
						this.updatePosition()
					})
					.catch((e) => {
						console.error(e)
					})
			}
		},

		updatePosition() {
			let activities = JSON.parse(JSON.stringify(this.activities))
			let obj = activities.find((obj) => {
				return obj.hierarchy_order === this.hierarchy_order
			})
			if (obj) {
				obj.current_time = this.current_time
				this.$store.dispatch('activities/SET_ACTIVITIES', [activities])
			}
		},

		playVideo() {
			if (!this.changed_time) {
				this.player.currentTime = this.activity.current_time
				this.changed_time = true
			}

			this.interval = setInterval(() => {
				this.sendPosition()
			}, 15000)
		},

		pauseVideo() {
			this.sendPosition()
			clearInterval(this.interval)
		},

		endedVideo() {
			this.$q.loading.show()

			this.sendPosition()
			clearInterval(this.interval)
			this.player.stop()

			if (!this.activity.user_watch) {
				setTimeout(() => {
					this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
						this.activity,
						{ user_watch: true },
					])
					this.$emit('finish')
					this.$q.loading.hide()
				}, 500)
			}
			this.$q.loading.hide()
		},

		videoTimeUpdated(val) {
			this.current_time = val.detail.plyr.currentTime
		},

		youtubeParser(url) {
			this.source = url
		},

		seekVideo(e) {
			return false
		},
	},

	mounted() {
		this.player.on('timeupdate', (val) => this.videoTimeUpdated(val))
		this.player.on('play', (val) => this.playVideo())
		this.player.on('pause', (val) => this.pauseVideo())
		this.player.on('ended', (val) => this.endedVideo())
		
	},

	created() {
		if (this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
		if (this.$route.params.id) this.id_course = this.$route.params.id
		this.youtubeParser(`${this.activity.resource}`)
	},
}
</script>

<style></style>
